import React, { useState } from 'react';
import { FormInput } from "components";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, MessageBlock} from '@cfa/react-components';
import { parseAxiosError, UpdateFilesService } from 'services';
import { useForm } from 'react-hook-form';

import './UploadFileModal.scss';

interface IUploadFileModalProps {
    onHide: () => void,
    onUpload: (uri: string) => void,
}
type IUploadUpdateFileForm = {
    key: string,
    file: File,
}

export function UploadFileModal({ onHide, onUpload }: IUploadFileModalProps) {
    const form = useForm<IUploadUpdateFileForm>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const upload  = () => {
        form.handleSubmit((data) => {
            setError("");
            setLoading(true);

            UpdateFilesService.uploadUpdateFile(data.key, data.file[0])
                .then((response) => {
                    onUpload(response.s3URI);
                })
                .catch((e) => {
                    setLoading(false);
                    setError(parseAxiosError(error));
                })
        })();
    }

    return (<>
        <ModalHeader>
            Upload Update File
        </ModalHeader>
        <ModalBody>
            {error !== "" && (
            <MessageBlock severity="error" title="Error">
                {error}
            </MessageBlock>
            )}
            <Row>
                <FormInput
                    form={form}
                    label="Name"
                    name="key"
                    registerOptions={{ required: true }}
                />
            </Row>
            <Row>
                <FormInput
                    form={form}
                    label="File"
                    name="file"
                    type="file"
                    registerOptions={{ required: true }}
                />
            </Row>
        </ModalBody>
        <ModalFooter>
            <Button variant="outlined" onClick={onHide} disabled={loading}>Cancel</Button>
            <Button onClick={upload} loading={loading}>Upload</Button>
        </ModalFooter>
    </>);
}
